//--------------------------------- API Settings ----------------------------------//

const BASE_BACK_END_URL = window.BACK_END_URL;

const BACK_END_API_URL = BASE_BACK_END_URL + "/api/";

const BACK_END_API_END_POINTS = {
	users: {
		getUserWithTokens: {
			url: "users/retrieve_user_with_tokens/",
			method: "POST",
		},
		getUserRefreshedTokens: {
			url: "users/retrieve_user_refreshed_tokens/",
			method: "POST",
		},
		RUser: {
			url: "users/retrieve_user",
			method: "POST",
		},
	},
	customers: {
		RCustomers: {
			url: "customers/retrieve-bulk",
			method: "POST",
		},
		UCustomers: {
			url: "customers/update_customers",
			method: "POST",
		},
	},
	products: {
		RProducts: {
			url: "products/retrieve_products",
			method: "POST",
		},
		RProductCategories: {
			url: "products/categories/retrieve_product_categories",
			method: "POST",
		},
		// Admin Product Endpoints
		adminListTrashedProducts: {
			url: "products/admin_list_trashed",
			method: "POST",
		},
		adminCreateProduct: {
			url: "products/admin_create_product",
			method: "POST",
		},
		adminUpdateProduct: {
			url: "products/admin_update_product",
			method: "POST",
		},
		adminUpdateProductImage: {
			url: "products/admin_update_product_image",
			method: "POST",
		},
		adminTrashProduct: {
			url: "products/admin_trash_product",
			method: "POST",
		},
		adminRestoreProduct: {
			url: "products/admin_restore_product",
			method: "POST",
		},
		// Admin Category Endpoints
		adminListTrashedCategories: {
			url: "products/categories/admin_list_trashed",
			method: "POST",
		},
		adminCreateCategory: {
			url: "products/categories/admin_create_category",
			method: "POST",
		},
	},
	orders: {
		ROrders: {
			url: "orders/retrieve-bulk",
			method: "POST",
			default_order_by: ["-created_on"],
		},
		RServiceRequests: {
			url: "orders/retrieve-service-requests",
			method: "POST",
			default_order_by: ["-created_on"],
		},
		RBackorderedOrders: {
			url: "orders/retrieve-backordered",
			method: "POST",
			default_order_by: ["-created_on"],
		},
		COrders: {
			url: "orders/create_orders",
			method: "POST",
		},
		UOrders: {
			url: "orders/update_orders",
			method: "POST",
		},
		UCartItemStatus: {
			url: "orders/update_cart_item_status",
			method: "POST",
		},
	},
};

// API Keys
// const GOOGLE_MAPS_API_KEY = "";

export { BACK_END_API_URL, BACK_END_API_END_POINTS };
